import { Box, Flex, styled } from '@grupoboticario/flora-react';

const styles = {
  ButtonContactWrapper: styled(Box, {
    width: '50%',

    '@tablet': {
      width: 'initial',
    },

    a: {
      width: '100%',
    },
  }),

  Wrapper: styled(Flex, {
    flexWrap: 'wrap',

    '@tablet': {
      flexWrap: 'nowrap',
    },
  }),
};

export default styles;
